import { Box } from 'react-scale/components/pages/homepage/build-ai/box';
import CurationIllustration from 'react-scale/components/pages/homepage/build-ai/curation-illustration';
import CTA from 'react-scale/components/elements/cta';

export const BoxDataCuration = () => {
  return (
    <Box
      inverted
      title="Data Curation"
      subtitle="Unearth the most valuable data by intelligently managing your dataset."
      imageHTML={<CurationIllustration inverted />}
    >
      <p className="mt-6 mb-8 text-sm md:text-base text-black sm:text-white">
        Scale’s suite of dataset management, testing, model evaluation, and model comparison tools
        enable you to “label what matters.” Maximize the value of your labeling budget by
        identifying the highest value data to label, even without ground truth&nbsp;labels.
      </p>
      {/* @ts-ignore: Unreachable code error */}
      <CTA
        cta={{
          buttons: [
            {
              text: 'Learn More',
              href: '/data-engine',
              type: 'primary',
              variant: 'black-transparent'
            },
            {
              text: 'Curate My Data',
              href: 'https://dashboard.scale.com/nucleus',
              type: 'secondary'
            }
          ]
        }}
      />
    </Box>
  );
};
